class DatesHelper {
  static setErrorIfInvalid(date, field, setError) {
    if (date.toString() === "Invalid Date") {
      setError(field, {
        type: "custom",
        message: "Please set a valid date",
      });
      return false;
    }
    return true;
  }
}
export default DatesHelper;
